import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Compact — tighter spacing, smaller type scale, fits more on one page.
export const compactStyles = {
  meta: { label: "Compact (dense)" },

  page: {
    paddingTop: 36,
    paddingBottom: 36,
    paddingLeft: 48,
    paddingRight: 48,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.sans,
    fontSize: TYPE.body - 0.5,
    color: COLORS.navy,
    lineHeight: 1.38,
  },

  header: { marginBottom: 10 },
  headerName: {
    fontSize: TYPE.name - 2,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
    letterSpacing: 0.3,
    marginBottom: 2,
  },
  headerHeadline: {
    fontSize: TYPE.body,
    color: COLORS.slate,
    marginTop: 12,
  },
  headerContact: {
    fontSize: TYPE.micro - 0.5,
    color: COLORS.slate,
    marginTop: 4,
    flexDirection: "row",
    flexWrap: "wrap",
  },
  sep: { color: COLORS.mute },

  section: { marginTop: 10 },
  sectionHeadingWrap: { marginBottom: 4 },
  sectionHeading: {
    fontSize: TYPE.micro - 0.5,
    fontFamily: FONTS.sansBold,
    textTransform: "uppercase",
    letterSpacing: 2,
    color: COLORS.mute,
  },
  sectionRule: {
    borderBottomWidth: 0.5,
    borderBottomColor: COLORS.mute,
    marginTop: 2,
    marginBottom: 5,
  },

  itemGroup: { marginBottom: 7 },
  itemGroupTight: { marginBottom: 3 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { fontFamily: FONTS.sans, color: COLORS.slate },
  itemTitleMuted: { fontFamily: FONTS.sans, color: COLORS.mute },
  itemSubtitle: {
    fontSize: TYPE.meta,
    color: COLORS.slate,
    marginTop: 1,
  },
  itemDate: { fontSize: TYPE.micro, color: COLORS.mute },

  body: { fontSize: TYPE.body - 0.5, color: COLORS.navy, marginTop: 2 },
  meta: { fontSize: TYPE.meta - 0.5, color: COLORS.slate, marginTop: 1 },
  chipsLine: { fontSize: TYPE.meta - 0.5, marginTop: 2, color: COLORS.slate },
  labelStrong: { fontFamily: FONTS.sansBold, color: COLORS.navy },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 3 },
  bulletRow: { flexDirection: "row", marginBottom: 1 },
  bulletMark: { width: 9, fontSize: TYPE.body - 0.5, color: COLORS.mute },
  bulletText: { flex: 1, fontSize: TYPE.body - 0.5, color: COLORS.navy },

  link: { color: COLORS.rust, textDecoration: "underline" },
  linkSmall: {
    color: COLORS.rust,
    textDecoration: "underline",
    fontSize: TYPE.micro,
  },
};
